<template lang="pug">
  app-dialog(v-model="$_show" header="Профиль участника дела" confirm-text="Создать" :confirm-disabled="isNotReady" @confirm="editMember")
    v-form(v-model="valid" ref="form")
      v-tabs.tabs(v-model="tabs" grow color="transparent" height="35" centered slider-color="#1B93AD" active-class="tabs__item--active" light)
        v-tab.tabs__item.text-none(:disabled="member && member.persona.personaType.name != 'FL'") Физическое лицо
        v-tab.tabs__item.text-none(:disabled="member && member.persona.personaType.name != 'UL'") Юридическое лицо
        v-tab.tabs__item.text-none(:disabled="member && member.persona.personaType.name != 'DL'") Должностное лицо
        
      v-tabs-items.mt-6(v-model="tabs" light)
        // Individual
        v-tab-item
          app-text-field(v-model="form.persona.name" label="ФИО")
          app-date-picker(v-model="form.persona.birthDate" label="Дата рождения")

        // Legal
        v-tab-item
          app-text-field(v-model="form.persona.orgName" label="Наименование")
          app-text-field(v-model="form.persona.orgINN" label="ИНН")
          app-text-field(v-model="form.persona.orgKPP" label="КПП")
          app-text-field(v-model="form.persona.name" label="ФИО представителя")
        
        // Official
        v-tab-item
          app-text-field(v-model="form.persona.name" label="ФИО")

      app-select(v-model="form.status" :items="memberStatuses" label="Статус" item-text="title" return-object)

      app-combobox(v-model="phoneItems" :items="phoneItems" item-text="data" label="Телефон")
      app-combobox(v-model="emailSearch" :items="emailSearch" item-text="data" label="Email")
      app-combobox(v-model="addressItems" :items="addressItems" item-text="data" label="Адрес")

      app-textarea(v-model="form.persona.note" label="Комментарий")

</template>

<script>
import { AppDialogToggable } from '@/components'
import { memberType } from './constants.js'
import { mapGetters } from 'vuex'
import { memberService } from "@/_services"

export default {
  mixins: [AppDialogToggable],

  props: {
    member: null,
    type: {
      type: Number,
      default: memberType.individual
    }
  },

  data () {
    const defaultForm = Object.freeze({
      status: '',
      persona: { 
        name: '',
        birthDate: '',
        orgName: '',
        orgINN: '',
        orgKPP: '',
        note: '',
        personaData: [],
        personaType: {
          name: 'FL'
        },
      },
    })

    return {
      valid: true,
      tabs: null,

      emailItems: [],
      emailSearch: null,

      phoneItems: [],
      phoneSearch: null,

      addressItems: [],
      addressSearch: null,

      form: Object.assign({}, defaultForm),
      memberType,
      defaultForm
    }
  },

  watch: {
    $_show (value) {
      if (value) {
        let baseObj = this.member || this.defaultForm
        this.form = JSON.parse(JSON.stringify(baseObj))

        let personData = this.form.persona.personaData
        this.phoneItems = personData.filter(item => item.dataType.name === 'PHONE')
        this.emailItems = personData.filter(item => item.dataType.name === 'EMAIL')
        this.addressItems = personData.filter(item => item.dataType.name === 'ADDRESS')

        this.tabs = (this.member && this.member.persona.personaType.name === 'UL') ? 1 : (this.member && this.member.persona.personaType.name === 'DL') ? 2 : 0
      }
    }
  },

  computed: {
    ...mapGetters('courtCase', ['memberStatuses', 'caseId']),

    isNotReady () {
      if (!this.form.persona.name) return true
      if (this.tabs == 1 && ( !this.form.persona.orgName || !this.form.persona.orgINN || !this.form.persona.orgKPP )) return true
      if (this.addressItems.length == 0 || this.phoneItems.length == 0 || this.emailItems.length == 0) return true
      if (!this.form.status) return true
      return false
    },

    emailsData () {
      return this.emailItems.map(item => (item instanceof Object) ? item : { data: item, dataType: 'EMAIL' })
    },

    phonesData () {
      return this.phoneItems.map(item => (item instanceof Object) ? item : { data: item, dataType: 'PHONE' })
    },

    addressesData () {
      return this.addressItems.map(item => (item instanceof Object) ? item : { data: item, dataType: 'ADDRESS' })
    },
  },

  methods: {
    editMember () {
      let otherData = this.form.persona.personaData.filter(obj => obj.dataType.name !== 'ADDRESS' && obj.dataType.name !== 'EMAIL' && obj.dataType.name !== 'PHONE')
      this.form.persona.personaData = otherData.concat(this.emailsData, this.addressesData, this.phonesData)
      this.form.persona.personaType = this.form.persona.personaType.name
      this.form.persona.birthDate = `${this.form.persona.birthDate} 00:00`

      this.member ? this.updateMember() : this.createMember()
    },

    createMember () {
      memberService.create(this.caseId, this.form)
      .then(() => {
        this.$store.dispatch('courtCase/LOAD_CASE', this.caseId)
      })
    },
    
    updateMember() {
      memberService.update(this.form)
      .then(() => {
        this.$store.dispatch('courtCase/LOAD_CASE', this.caseId)
      })
    },

    updateEditedPerson() {
      // Update persona
      let personaData = this.editMember.persona.personaData.map((value) => {
        value.dataType = value.dataType.name
        return value
      })
      this.editMember.persona.personaData = personaData

      memberService.updatePersona(  this.editMember.persona )
      .then(() => {
        this.modals.user.edit.notice = false
        this.currentMember = null
        this.loadCase()
      })
    },
  }
}
</script>

<style>
.tabs__item--active {
  color: #0E9DBC !important;
}
</style>

<style lang="scss" scoped>
.tabs__item {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;

  color: #757575;
}

</style>

